import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-success alert-dismissible fade show",
  role: "alert"
}
const _hoisted_7 = {
  key: 1,
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
}
const _hoisted_8 = {
  key: 2,
  class: "text-center my-4"
}
const _hoisted_9 = {
  key: 3,
  class: "row mb-4"
}
const _hoisted_10 = { class: "col-12 mb-3" }
const _hoisted_11 = { class: "form-check" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = {
  key: 4,
  class: "table-responsive"
}
const _hoisted_17 = { class: "table table-bordered table-hover" }
const _hoisted_18 = ["onUpdate:modelValue", "onChange"]
const _hoisted_19 = {
  key: 0,
  class: "text-center"
}
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = ["value"]
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["value"]
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["value"]
const _hoisted_26 = ["onClick", "disabled"]
const _hoisted_27 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}
const _hoisted_28 = { key: 0 }

import { ref, computed, onMounted } from 'vue';
import { useToast } from 'vue-toastification';
import axios from 'axios';

interface SiddarEmployee {
    _id: string;
    siteName: string;
    siteId: string;
    department: string;
    employee: string;
    employeeId: string;
    designation: string;
    gender: string;
    daysWorked: number;
    typeOfLeaving: string;
    type: string;
    vacentType: string;
    reason: string;
    manager: string;
    deadline: string;
    status: string;
    createdAt: string;
    recuitmentDeadline: string;
}

interface VacantSite {
    siteName: string;
    siteUID: string;
    siteId: string;
    vacancies: number;
}

interface Employee {
    id: string;
    employeeId: string;
    siteId: string;
    name: string;
    currentSite: string;
    department: string;
    designation: string;
    changeOption: string;
    newSite: string;
    newRelieverType: string | number;
    createdAt?: string;
    manager: string;
}

interface Site {
    id: string;
    name: string;
}

interface RelieverType {
    id: number;
    name: string;
}

interface TransferResponse {
    success: boolean;
    message: string;
    data?: {
        employeeId: string;
        previousSite: string;
        newSite: string;
        transferDate: string;
    };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'change-siddars',
  setup(__props) {

const baseUrl = process.env.VUE_APP_BASE_URL;

// Initialize toast
const toast = useToast();

// State
const notification = ref('');
const currentUser = ref('');
const filters = ref({
    includeVacant: false,
    dateFrom: '',
    dateTo: ''
});

const employees = ref<Employee[]>([]);
const loading = ref(false);
const error = ref('');

const vacantSites = ref<VacantSite[]>([]);
const loadingVacantSites = ref(false);

const availableSites = ref<Site[]>([
    { id: 'site-1', name: 'Site A' },
    { id: 'site-2', name: 'Site B' },
    { id: 'site-3', name: 'Site C' }
]);

const relieverTypes = ref<RelieverType[]>([
    { id: 1, name: 'General Reliever' },
    { id: 2, name: 'Special Reliever' },
    { id: 3, name: 'Emergency Reliever' }
]);

// Fetch employees data
const fetchEmployees = async () => {
    try {
        loading.value = true;
        error.value = '';
        const response = await axios.get(`${baseUrl}api/siddar/get/change`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        
        // Transform the API response to match our Employee interface
        employees.value = response.data.map((item: SiddarEmployee) => ({
            id: item._id,
            employeeId: item.employeeId,
            siteId: item.siteId,
            name: item.employee,
            currentSite: item.siteName,
            department: item.department,
            designation: item.designation,
            changeOption: '',
            newSite: '',
            newRelieverType: '',
            createdAt: item.createdAt,
            manager: item.manager
        }));

        // Set current user from the first record's manager (assuming it's consistent)
        if (response.data.length > 0) {
            currentUser.value = response.data[0].manager;
        }
    } catch (err) {
        error.value = 'Failed to fetch employees data';
        console.error('Error fetching employees:', err);
    } finally {
        loading.value = false;
    }
};

// Fetch vacant sites
const fetchVacantSites = async () => {
    try {
        loadingVacantSites.value = true;
        const response = await axios.get(`${baseUrl}api/temp/sites/vacant`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        
        if (response.data.success) {
            vacantSites.value = response.data.data;
        } else {
            throw new Error(response.data.message || 'Failed to fetch vacant sites');
        }
    } catch (err) {
        console.error('Error fetching vacant sites:', err);
        toast.error('Failed to fetch vacant sites');
    } finally {
        loadingVacantSites.value = false;
    }
};

// Computed
const filteredEmployees = computed(() => {
    let filtered = [...employees.value];

    if (!filters.value.includeVacant) {
        filtered = filtered.filter(emp => emp.currentSite !== 'Vacant');
    }

    if (filters.value.dateFrom || filters.value.dateTo) {
        filtered = filtered.filter(emp => {
            if (!emp.createdAt) return true;
            
            const empDate = new Date(emp.createdAt);
            const fromDate = filters.value.dateFrom ? new Date(filters.value.dateFrom) : null;
            const toDate = filters.value.dateTo ? new Date(filters.value.dateTo) : null;

            if (fromDate && toDate) {
                return empDate >= fromDate && empDate <= toDate;
            } else if (fromDate) {
                return empDate >= fromDate;
            } else if (toDate) {
                return empDate <= toDate;
            }
            return true;
        });
    }

    return filtered;
});

// Methods
const handleChangeOption = async (employee: Employee) => {
    employee.newSite = '';
    employee.newRelieverType = '';

    if (employee.changeOption === 'vacant_site') {
        await fetchVacantSites();
    }
};

const isChangeValid = (employee: Employee) => {
    if (!employee.changeOption) return false;
    
    if (employee.changeOption === 'vacant_reliever' && !employee.newRelieverType) return false;
    if ((employee.changeOption === 'transfer' || employee.changeOption === 'vacant_site') && !employee.newSite) return false;
    
    return true;
};

const getRelieverTypeName = (id: string | number) => {
    const numericId = typeof id === 'string' ? parseInt(id) : id;
    return relieverTypes.value.find(type => type.id === numericId)?.name || '';
};

const applyChange = async (employee: Employee) => {
    try {
        let message = '';
        
        switch (employee.changeOption) {
            case 'vacant_site':
                loading.value = true;
                const transferResponse = await axios.post<TransferResponse>(
                    `${baseUrl}api/temp/transfer/employee`,
                    {
                        employeeId: employee.employeeId,
                        previousSiteId: employee.siteId,
                        newSiteId: employee.newSite,
                        siddarId: employee.id
                    },
                    {
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );

                if (transferResponse.data.success) {
                    const vacantSite = vacantSites.value.find(site => site.siteId === employee.newSite);
                    message = `${employee.name} has been transferred from ${transferResponse.data.data?.previousSite} to ${transferResponse.data.data?.newSite} by ${employee.manager}`;
                    
                    // Refresh the employee list after successful transfer
                    await fetchEmployees();
                } else {
                    throw new Error(transferResponse.data.message || 'Transfer failed');
                }
                break;

            case 'vacant_reliever':
                message = `${employee.name} has been assigned as ${getRelieverTypeName(employee.newRelieverType)} by ${employee.manager}`;
                break;

            case 'transfer':
                const newSiteName = availableSites.value.find(site => site.id === employee.newSite)?.name;
                message = `${employee.name} has been transferred from ${employee.currentSite} to ${newSiteName} by ${employee.manager}`;
                break;
        }

        // Show notification
        notification.value = message;
        
        // Show toast notification
        toast.success(message, {
            timeout: 30 * 24 * 60 * 60 * 1000 // 30 days in milliseconds
        });

        // Reset the employee's change options
        employee.changeOption = '';
        employee.newSite = '';
        employee.newRelieverType = '';

    } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'An error occurred while applying the change';
        toast.error(errorMessage);
        error.value = errorMessage;
    } finally {
        loading.value = false;
    }
};

// Initialize data on component mount
onMounted(() => {
    fetchEmployees();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "card-header pb-0" }, [
            _createElementVNode("h5", null, "Change Siddar")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            (notification.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(notification.value) + " ", 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-close",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (notification.value = '')),
                    "aria-label": "Close"
                  })
                ]))
              : _createCommentVNode("", true),
            (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createTextVNode(_toDisplayString(error.value) + " ", 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-close",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (error.value = '')),
                    "aria-label": "Close"
                  })
                ]))
              : _createCommentVNode("", true),
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("div", {
                    class: "spinner-border text-primary",
                    role: "status"
                  }, [
                    _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            (!loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        id: "includeVacant",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.includeVacant) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, filters.value.includeVacant]
                      ]),
                      _cache[6] || (_cache[6] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "includeVacant"
                      }, " Include All Current Vacant Positions Irrespective of Time Period ", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form-label" }, "From Date", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.dateFrom) = $event))
                        }, null, 512), [
                          [_vModelText, filters.value.dateFrom]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label" }, "To Date", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.value.dateTo) = $event))
                        }, null, 512), [
                          [_vModelText, filters.value.dateTo]
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("table", _hoisted_17, [
                    _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Employee Name"),
                        _createElementVNode("th", null, "Current Site"),
                        _createElementVNode("th", null, "Department"),
                        _createElementVNode("th", null, "Designation"),
                        _createElementVNode("th", null, "Change Option"),
                        _createElementVNode("th", null, "New Site / Reliever Type"),
                        _createElementVNode("th", null, "Done By"),
                        _createElementVNode("th", null, "Action")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEmployees.value, (employee) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: employee.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(employee.name), 1),
                          _createElementVNode("td", null, _toDisplayString(employee.currentSite), 1),
                          _createElementVNode("td", null, _toDisplayString(employee.department), 1),
                          _createElementVNode("td", null, _toDisplayString(employee.designation), 1),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select",
                              "onUpdate:modelValue": ($event: any) => ((employee.changeOption) = $event),
                              onChange: ($event: any) => (handleChangeOption(employee))
                            }, [...(_cache[9] || (_cache[9] = [
                              _createElementVNode("option", { value: "" }, "Select Option", -1),
                              _createElementVNode("option", { value: "vacant_site" }, "Vacant Site", -1),
                              _createElementVNode("option", { value: "vacant_reliever" }, "Vacant Reliever", -1),
                              _createElementVNode("option", { value: "transfer" }, "Transfer to Another Site", -1)
                            ]))], 40, _hoisted_18), [
                              [_vModelSelect, employee.changeOption]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            (employee.changeOption === 'vacant_site')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (loadingVacantSites.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[10] || (_cache[10] = [
                                        _createElementVNode("div", {
                                          class: "spinner-border spinner-border-sm",
                                          role: "status"
                                        }, [
                                          _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                                        ], -1)
                                      ]))]))
                                    : _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 1,
                                        class: "form-select",
                                        "onUpdate:modelValue": ($event: any) => ((employee.newSite) = $event)
                                      }, [
                                        _cache[11] || (_cache[11] = _createElementVNode("option", { value: "" }, "Select Vacant Site", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vacantSites.value, (site) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: site.siteUID,
                                            value: site.siteId
                                          }, _toDisplayString(site.siteName) + " (" + _toDisplayString(site.vacancies) + " vacancies) ", 9, _hoisted_21))
                                        }), 128))
                                      ], 8, _hoisted_20)), [
                                        [_vModelSelect, employee.newSite]
                                      ])
                                ], 64))
                              : (employee.changeOption === 'vacant_reliever')
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 1,
                                    class: "form-select",
                                    "onUpdate:modelValue": ($event: any) => ((employee.newRelieverType) = $event)
                                  }, [
                                    _cache[12] || (_cache[12] = _createElementVNode("option", { value: "" }, "Select Reliever Type", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relieverTypes.value, (type) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: type.id,
                                        value: type.id
                                      }, _toDisplayString(type.name), 9, _hoisted_23))
                                    }), 128))
                                  ], 8, _hoisted_22)), [
                                    [_vModelSelect, employee.newRelieverType]
                                  ])
                                : (employee.changeOption === 'transfer')
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 2,
                                      class: "form-select",
                                      "onUpdate:modelValue": ($event: any) => ((employee.newSite) = $event)
                                    }, [
                                      _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, "Select New Site", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableSites.value, (site) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: site.id,
                                          value: site.id
                                        }, _toDisplayString(site.name), 9, _hoisted_25))
                                      }), 128))
                                    ], 8, _hoisted_24)), [
                                      [_vModelSelect, employee.newSite]
                                    ])
                                  : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(employee.manager), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "btn btn-primary",
                              onClick: ($event: any) => (applyChange(employee)),
                              disabled: !isChangeValid(employee) || loading.value
                            }, [
                              (loading.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, [...(_cache[14] || (_cache[14] = [
                                    _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(loading.value ? 'Applying...' : 'Apply Change'), 1)
                            ], 8, _hoisted_26)
                          ])
                        ]))
                      }), 128)),
                      (!filteredEmployees.value.length)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [...(_cache[15] || (_cache[15] = [
                            _createElementVNode("td", {
                              colspan: "8",
                              class: "text-center"
                            }, "No employees found", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})